import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Snap_SVG from 'snapsvg';
import Cache from 'root/cache';
import Router from 'root/router';
import Util from 'root/module/util';
import Modals from 'root/modals';
import SVG from 'root/module/svg_icon';
import PDFJS from 'root/module/pdfjs';
import Modal from 'root/module/modal';
import View from 'view/base';
import Video_Capture from 'root/module/video_capture';
import View_Feedback_Actions from 'view/feedback_viewer/actions';
import View_Feedback_Details from 'view/feedback_viewer/details';
import View_Dev_Tools from 'view/dev_tools';
import View_Feedback_Session_Recording from 'view/feedback_viewer/session_recording';
import View_Feedback_Revision_Dropdown from 'view/feedback_viewer/revision_dropdown';
import View_Feedback_Pdf_Pagination from 'view/feedback_viewer/pdf_pagination';
import View_Feedback_Screenshot_Thumbnail from 'view/feedback_viewer/screenshot_thumbnail';
import View_Feedback_Thread from 'view/feedback_viewer/thread';
import View_Feedback_Pin_Comment from 'view/feedback_viewer/pin_comment';
import View_Feedback_Video_Player from 'view/feedback_viewer/video_player';

export default View.extend({
    className: 'feedback-viewer',
    not_found: false,

    screenshot_width  : 0,
    screenshot_height : 0,

    screenshot_zoom_level: 100,

    screenshot_zoom_level_cache: {},
    pdf_cache: {},

    screenshot_num: 0,

    is_video_recording: false,
    drag_start: false,

    nav: '',
    nav_count: 0,

    tool_type: 'eye-open',
    snap: null,

    comment_type: 'open',

    screenshot_click_time: 0,
    draw_started: false,

    dispatcher: _.extend({}, Backbone.Events),

    views: {
        thread: {},
        pin_comments: {},
        details: {},
        actions: {},
        video_player: {},
        revision_dropdown: {},
        pdf_pagination: {},
        screenshot_thumbnail: {},
        dev_tools: {},
        session: {},
        session_replay: {}
    },

    events: {
        'click .viewer-close'              : 'closeViewer',
        'click .sidebar-toggle'            : 'toggleSidebar',
        'click .details-toggle'            : 'toggleDetails',
        'click .comment-toggle'            : 'toggleComment',
        'click .zoom-out'                  : 'zoomOut',
        'click .zoom-in'                   : 'zoomIn',
        'dragstart .screenshot'            : 'dragStart',
        'click .mobile-toggle'             : 'toggleDetailsInMobile',
        'click .comment-type-selection li' : 'selectCommentType',
        'click .local-warning-close'       : 'localWarningClose',
        'click .view-open-comments'        : 'viewOpenComments',
        'click .view-resolved-comments'    : 'viewResolvedComments',
        'mouseenter .annotation-canvas'    : 'screenshotMouseEnter',
        'mousemove .annotation-canvas'     : 'screenshotMouseMove',
        'mouseleave .annotation-canvas'    : 'screenshotMouseLeave',
        'click .annotation-canvas'         : 'screenshotClick',
        'touchend .annotation-canvas'      : 'screenshotClick',
        'click .annotation-tools button'   : 'chooseAnnotationTool',
        'blur .feedback-title-edit'        : 'feedbackTitleBlur',
        'keydown .feedback-title-edit'     : 'feedbackTitleKeyDown',
        'keyup .feedback-title-edit'       : 'feedbackTitleKeyUp',
        'click .profile-img-anon'          : 'updateAnonUser',
        'click .devtools-thumbnail'        : 'onToggleDevtools',
        'dragenter'                        : 'screenDragEnter',
        'dragover'                         : 'screenDragOver',
        'dragleave'                        : 'screenDragLeave',
        'drop'                             : 'screenDrop'
    },

    dom_handlers: {
        onToggleDevtools: function(e) {
            var container = this.$el.find('.region-screenshot-thumbnail');

            if (container.hasClass('active')) {
                container
                    .removeClass('active')
                    .css('height', ''); // reset draggable
            } else {
                container.addClass('active');
            }
        },

        closeViewer: function(e) {
            e.preventDefault();
            window.parent.postMessage({
                action: 'close'
            }, '*');
        },

        screenDragEnter: function(e) {
            if (!this.canUploadDesign()) {
                return;
            }

            e.preventDefault();
            this.$el.addClass('drag-over');
        },

        screenDragOver: function(e) {
            if (!this.canUploadDesign()) {
                return;
            }

            e.preventDefault();
            this.$el.addClass('drag-over');
        },

        screenDragLeave: function(e) {
            if (!this.canUploadDesign()) {
                return;
            }

            e.preventDefault();

            if ($(e.target).hasClass('feedback-viewer') || $(e.target).hasClass('dropzone')) {
                this.$el.removeClass('drag-over');
            }
        },

        screenDrop: function(e) {
            if (!this.canUploadDesign()) {
                return;
            }

            e.preventDefault();
            this.$el.removeClass('drag-over');

            this.views.revision_dropdown.dom_handlers.uploadImage.call(this.views.revision_dropdown, e.originalEvent);
        },

        updateAnonUser: function(e) {
            Modals.viewerGuest();
        },

        chooseAnnotationTool: function(e) {
            var tool_type = $(e.currentTarget).data('type');

            if (tool_type === 'video') {
                this.recordVideo();
            } else {
                if (tool_type === this.tool_type) {
                    return;
                }

                this.tool_type = tool_type;
                this.$el.attr('tooltype', this.tool_type);

                this.$el.find('.annotation-tools button').removeClass('active');
                $(e.currentTarget).addClass('active');

                if (tool_type === 'eye' || tool_type === 'eye-open') {
                    this.$el.find('.annotation-tools').find('button[data-type="eye"], button[data-type="eye-open"]')
                        .addClass('active')
                        .mouseenter(); // tooltip on hidden elements
                } else if (tool_type === 'comment') {
                    this.$el.find('.annotation-cursor-hint').text('Click to add a comment');
                } else {
                    this.$el.find('.annotation-cursor-hint').text('Click and drag to start');
                }
            }
        },

        screenshotMouseEnter: function(e) {
            if (['square', 'arrow', 'comment'].indexOf(this.tool_type) === -1) {
                return;
            }

            if (this.is_video_recording) {
                return;
            }

            this.setAnnotationTipPos(e);
            this.$el.find('.annotation-cursor-hint').show();
        },

        screenshotMouseMove: function(e) {
            if (['square', 'arrow', 'comment'].indexOf(this.tool_type) === -1) {
                return;
            }

            if (this.is_video_recording) {
                return;
            }

            this.setAnnotationTipPos(e);
        },

        screenshotMouseLeave: function(e) {
            if (this.is_video_recording) {
                return;
            }

            this.$el.find('.annotation-cursor-hint').hide();
        },

        feedbackTitleKeyDown: function(e) {
            if (e.which && e.which === 13) {
                e.preventDefault();
            }
        },

        feedbackTitleKeyUp: function(e) {
            var name = this.$el.find('.feedback-title-edit').text();

            if (e.which && e.which === 13) {
                this.$el.find('.feedback-title-edit').blur();

                if (this.model.get('load_type') === 'upload') {
                    this.renameDesign(name);
                } else {
                    this.renameFeedbackTitle(name);
                }
            }
        },

        feedbackTitleBlur: function(e) {
            var name = this.$el.find('.feedback-title-edit').text();

            if (this.model.get('load_type') === 'upload') {
                this.renameDesign(name);
            } else {
                this.renameFeedbackTitle(name);
            }
        },

        toggleSidebar: function(e) {
            if (this.$el.attr('theater')) {
                this.$el.removeAttr('theater');
                Router.removeQueryString('th');
            } else {
                this.$el.attr('theater', 1);
                Router.addQueryString('th', '1');
            }

            Util.transitionEnd(this.$el.find('.grid-main'), () => {
                $(window).trigger('resize');
            });
        },

        toggleDetails: function(e) {
            Router.addQueryString('t', 'd');

            this.$el.find('.region-details').show();
            this.$el.find('.region-comments').hide();

            this.$el.find('.details-toggle').addClass('active');
            this.$el.find('.comment-toggle').removeClass('active');

            // load history data
            this.views.details.loadHistory();
        },

        toggleComment: function(e) {
            Router.removeQueryString('t');

            this.$el.find('.region-details').hide();
            this.$el.find('.region-comments').show();

            this.$el.find('.details-toggle').removeClass('active');
            this.$el.find('.comment-toggle').addClass('active');
        },

        zoomOut: function(e) {
            var increment = 5;

            this.screenshot_zoom_level -= increment;
            this.screenshot_zoom_level = Math.max(this.screenshot_zoom_level, 10);

            this.screenshot_zoom_level_cache[this.screenshot_num] = this.screenshot_zoom_level;

            this.zoomScreenshot();
        },

        zoomIn: function(e) {
            var increment = 5;

            this.screenshot_zoom_level += increment;
            this.screenshot_zoom_level = Math.min(this.screenshot_zoom_level, 300);

            this.screenshot_zoom_level_cache[this.screenshot_num] = this.screenshot_zoom_level;

            this.zoomScreenshot();
        },

        documentKeydown: function(e) {
            if (!e.metaKey && !e.ctrlKey) {
                return;
            }

            if (e.which === 187) {
                e.preventDefault();
                this.dom_handlers.zoomIn.call(this);
            } else if (e.which === 189) {
                e.preventDefault();
                this.dom_handlers.zoomOut.call(this);
            }
        },

        dragStart: function(e) {
            e.preventDefault();
        },

        documentKeyup: function(e) {
            if (e.target.tagName === 'TEXTAREA' || e.target.tagName === 'INPUT' || e.target.tagName === 'SELECT') {
                return;
            }

            if ($(e.target).prop('contenteditable') == 'true') {
                return;
            }

            switch (e.which) {
                case 27:
                    if (this.in_app) {
                        this.$el.find('.viewer-close').click();
                    }

                    break;
            }
        },

        toggleDetailsInMobile: function(e) {
            $('body').toggleClass('feedback-viewer-show-details');
        },

        selectCommentType: function(e) {
            this.comment_type = $(e.currentTarget).data('type');
            this.updateCommentTypeDropdown();

            Router.addQueryString('s', this.comment_type);
        },

        viewOpenComments: function(e) {
            e.preventDefault();
            this.$el.find('.comment-type-selection li[data-type="open"]').click();
        },

        viewResolvedComments: function(e) {
            e.preventDefault();
            this.$el.find('.comment-type-selection li[data-type="resolved"]').click();
        },

        localWarningClose: function(e) {
            this.$el.find('.local-warning').remove();

            Cache.app.request({
                action: 'project/dismissLocal'
            });
        },

        screenshotClick: function(e) {
            if (this.model.get('load_type') !== 'upload') {
                return;
            }

            if (!this.canComment()) {
                return;
            }

            if (this.is_video_recording) {
                return;
            }

            if (this.tool_type !== 'comment') {
                return;
            }

            if (!$(e.target).hasClass('annotation-canvas')) {
                return;
            }

            var screenshot_click_time = (new Date()).getTime();

            if (Math.abs(screenshot_click_time - this.screenshot_click_time) <= 50) {
                this.screenshot_click_time = screenshot_click_time;
                return;
            }

            this.screenshot_click_time = screenshot_click_time;

            var offset_x, offset_y;

            if (e.type === 'touchend') {
                var canvas_offset = this.$el.find('.annotation-canvas').offset();
                offset_x = e.originalEvent.changedTouches[0].clientX - canvas_offset.left;
                offset_y = e.originalEvent.changedTouches[0].clientY - canvas_offset.top;
            } else {
                offset_x = e.offsetX;
                offset_y = e.offsetY;
            }

            var screen_x = Math.round(offset_x / (this.screenshot_zoom_level / 100));
            var screen_y = Math.round(offset_y / (this.screenshot_zoom_level / 100));

            var screen_number = 0;
            _.each(Cache.feedback_comment.where({feedback_id: this.model.id, screenshot_num: this.screenshot_num}), function(model) {
                if (model.get('screen_number')) {
                    screen_number = Math.max(screen_number, model.get('screen_number'));
                }
            });

            this.postComment(this.screenshot_num, screen_number + 1, screen_x, screen_y, 0, 0, '');
        },

        touchStart: function(e) {
            e.preventDefault();
            this.dom_handlers.drawStart.call(this, e.changedTouches[0].clientX, e.changedTouches[0].clientY, e);
        },

        touchMove: function(e) {
            e.preventDefault();
            this.dom_handlers.drawMove.call(this, 0, 0, e.changedTouches[0].clientX, e.changedTouches[0].clientY, e);
        },

        touchStop: function(e) {
            e.preventDefault();
            this.dom_handlers.drawStop.call(this, e);
        },

        drawStart: function(x, y, e) {
            if (this.tool_type !== 'square' && this.tool_type !== 'arrow') {
                return;
            }

            if (this.is_video_recording) {
                return;
            }

            if (this.draw_started) {
                return;
            }

            if (!$(e.target).hasClass('annotation-canvas')) {
                return;
            }

            this.draw_started = true;

            var canvas_offset = this.$el.find('.annotation-canvas').offset();

            var offset_x = x - canvas_offset.left;
            var offset_y = y - canvas_offset.top;

            var screen_x  = parseInt(offset_x / this.screenshot_zoom_level * 100, 10);
            var screen_y  = parseInt(offset_y / this.screenshot_zoom_level * 100, 10);

            Cache.feedback_comment.add({
                id              : '_temp',
                account         : Cache.account.id,
                project_id      : this.model.get('project_id'),
                annotation_type : this.tool_type,
                screenshot_num  : this.screenshot_num,
                screen_x        : screen_x,
                screen_y        : screen_y,
                start_x         : screen_x,
                start_y         : screen_y,
                screen_number   : 999
            });

            this.$el.attr('drawing', 1);
        },

        drawMove: function(dx, dy, x, y, e) {
            if (this.tool_type !== 'square' && this.tool_type !== 'arrow') {
                return;
            }

            if (this.is_video_recording) {
                return;
            }

            if (!this.draw_started) {
                return;
            }

            var canvas_el = this.$el.find('.annotation-canvas');

            var canvas_offset = canvas_el.offset();
            var stroke_size   = this.tool_type === 'square' ? 4 : 6;

            var offset_x = x - canvas_offset.left;
            var offset_y = y - canvas_offset.top;

            var screen_x  = offset_x / this.screenshot_zoom_level * 100;
            var screen_y  = offset_y / this.screenshot_zoom_level * 100;

            screen_x = Math.max(screen_x, stroke_size);
            screen_y = Math.max(screen_y, stroke_size);

            screen_x = Math.min(screen_x, canvas_el.width()  / this.screenshot_zoom_level * 100 - stroke_size);
            screen_y = Math.min(screen_y, canvas_el.height() / this.screenshot_zoom_level * 100 - stroke_size);

            Cache.feedback_comment.get('_temp').set({
                screen_x: parseInt(screen_x, 10),
                screen_y: parseInt(screen_y, 10)
            });
        },

        drawStop: function(e) {
            if (this.tool_type !== 'square' && this.tool_type !== 'arrow') {
                return;
            }

            if (this.is_video_recording) {
                return;
            }

            if (!this.draw_started) {
                return;
            }

            this.$el.removeAttr('drawing');
            this.draw_started = false;

            switch (this.tool_type) {
                case 'square':
                    var svg_width  = Math.abs(Cache.feedback_comment.get('_temp').get('start_x') - Cache.feedback_comment.get('_temp').get('screen_x'));
                    var svg_height = Math.abs(Cache.feedback_comment.get('_temp').get('start_y') - Cache.feedback_comment.get('_temp').get('screen_y'));

                    if (svg_width < 12 && svg_height < 12) {
                        Cache.feedback_comment.remove(Cache.feedback_comment.get('_temp'));

                        return;
                    }

                    break;
                case 'arrow':
                    var svg_width  = Math.abs(Cache.feedback_comment.get('_temp').get('start_x') - Cache.feedback_comment.get('_temp').get('screen_x'));
                    var svg_height = Math.abs(Cache.feedback_comment.get('_temp').get('start_y') - Cache.feedback_comment.get('_temp').get('screen_y'));

                    if (svg_width < 12 && svg_height < 12) {
                        Cache.feedback_comment.remove(Cache.feedback_comment.get('_temp'));

                        return;
                    }

                    break;
            }

            var screen_number = 0;
            _.each(Cache.feedback_comment.where({feedback_id: this.model.id, screenshot_num: this.screenshot_num}), function(model) {
                if (model.get('screen_number')) {
                    screen_number = Math.max(screen_number, model.get('screen_number'));
                }
            });

            // post
            this.postComment(
                this.screenshot_num, screen_number + 1,
                Cache.feedback_comment.get('_temp').get('screen_x'),
                Cache.feedback_comment.get('_temp').get('screen_y'),
                Cache.feedback_comment.get('_temp').get('start_x'),
                Cache.feedback_comment.get('_temp').get('start_y'),
                this.tool_type,
                () =>  {
                    Cache.feedback_comment.remove(Cache.feedback_comment.get('_temp'));
                });
        },

        windowResize: function(e) {
            this.zoomScreenshot();

            // set feedback title size
            this.$el.find('.feedback-title-edit').css({
                'max-width': this.$el.find('.region-heading').outerWidth(true) -
                                this.$el.find('.region-actions').outerWidth(true) -
                                this.$el.find('.profile-img').outerWidth(true) -
                                this.$el.find('.logo').outerWidth(true) -
                                100
            })
        },

        windowBeforeUnload: function(e) {
            if (this.hasUnsavedChanges()) {
                e.preventDefault();
                e.originalEvent.returnValue = true;
            }
        },

        onDragConsoleStart: function(e, ui) {
            ui.helper.data('panel_height', this.$el.find('.region-screenshot-thumbnail').height());
            ui.helper.data('offset_top_start', ui.offset.top);
        },

        onDragConsolePanel: function(e, ui) {
            var movement_y = ui.offset.top - ui.helper.data('offset_top_start');
            var height = ui.helper.data('panel_height') + movement_y * -1;

            this.$el.find('.region-screenshot-thumbnail').height(height);
        }
    },

    event_handlers: {
        screenshotChange: function() {
            this.$el.find('img.screenshot').attr('src', this.model.get('screenshot'));
        },

        onCommentAdd: function(model) {
            if (!model.get('reply_comment_id') && (model.get('screen_x') || model.get('video_number') || model.get('video_time'))) {
                var view = this.newThreadView(model);

                var check_order = model.get('video_time') > 0;
                this.renderThread(view, check_order);

                view.openReply();
            }

            if (model.get('screen_number')) {
                var view = this.newPinCommentView(model);
                this.renderPinComment(view);
                view.show();
                this.zoomScreenshot();
                view.open();
            } else if (model.get('video_number')) {
                this.dispatcher.trigger('Pin_Comment:Open', model.id);
            }

            this.updateCommentsTotal();
            this.updateCommentEmptyState();
        },

        onCommentRemove: function(model) {
            if (!model.get('reply_comment_id') && (model.get('screen_x') || model.get('video_number') || model.get('video_time'))) {
                if (this.views.thread['_' + model.id]) {
                    this.views.thread['_' + model.id].remove();
                    delete this.views.thread['_' + model.id];
                }

                if (this.views.pin_comments['_' + model.id]) {
                    this.views.pin_comments['_' + model.id].removeAnnotation();
                    this.views.pin_comments['_' + model.id].remove();
                    delete this.views.pin_comments['_' + model.id];
                }

            }

            this.updateCommentsTotal();
            this.updateCommentEmptyState();
        },

        onCommentChange: function() {
            this.updateCommentsTotal();
        },

        onCommentResolve: function() {
            this.updateCommentEmptyState();
        },

        onPageChange: function() {
            this.$el.find('.design-name').text(this.model.get('page'));
        },

        onDescriptionChange: function() {
            if (this.model.get('description') === '') {
                var desc_reply_comments = Cache.feedback_comment.where({reply_comment_id: 0, screen_number: 0, video_time: 0});

                if (desc_reply_comments.length === 0) {
                    if (typeof this.views.thread['_desc'] !== 'undefined') {
                        this.views.thread['_desc'].remove();
                    }
                }

                this.updateCommentEmptyState();
            }
        },

        onShareSettingsChange: function() {
            this.renderAnnotationTools();
        },

        onGuestUpdate: function() {
            this.renderUserProfile();
        },

        // when a visible thread is clicked
        onThreadSelect: function(view_cid, model_id) {
            if (!model_id) {
                return;
            }

            var feedback_comment = Cache.feedback_comment.get(model_id);

            if (feedback_comment) {
                // pin comment
                // scroll to it
                if (feedback_comment.get('screen_number')) {
                    var pin_comment_view = this.views.pin_comments['_' + model_id];
                    if (pin_comment_view) {
                        var scroll_container = this.$el.find('.region-screenshot');
                        var heading_height   = this.$el.find('.region-heading').outerHeight();

                        var offset_top  = pin_comment_view.$el.offset().top;
                        var scroll_top  = offset_top + scroll_container.scrollTop() - scroll_container.offset().top - 100;

                        if (offset_top < heading_height || offset_top > scroll_container.outerHeight()) {
                            scroll_container.scrollTop(scroll_top);
                        }
                    }
                }
            }
        },

        // when a visible pin comment or bookmart is clicked
        onPinCommentOpen: function(model_id) {
            this.$el.find('.comment-toggle').click();

            if (this.$el.attr('theater')) {
                this.$el.find('.sidebar-toggle').click();
            }

            var feedback_comment = Cache.feedback_comment.get(model_id);

            if (feedback_comment) {
                if (feedback_comment.get('is_resolved') && this.comment_type === 'open') {
                    this.$el.find('.comment-type-selection li[data-type="resolved"]').click();
                } else if (!feedback_comment.get('is_resolved') && this.comment_type === 'resolved') {
                    this.$el.find('.comment-type-selection li[data-type="open"]').click();
                }
            }
        },

        onScreenshotThumbnailSelect: function(model_id) {
            var screenshot_num = 0;

            Cache.feedback_screenshot.each(function(model, index) {
                if (model_id === model.id) {
                    screenshot_num = index;
                }
            });

            this.viewScreenshot(screenshot_num);
        },

        onPdfThumbnailSelect: function(page) {
            this.viewPdf(page);
        }
    },

    openFeedback: function(feedback_id) {
        Cache.app.request({
            action: 'feedback/getAttributes',
            data: {
                ids: [feedback_id],
            },
            success: (response) => {
                var feedback = response[0];

                if (!feedback) {
                    return;
                }

                var feedback_url = '/viewer/' + feedback.account_id + '/' + feedback.project_id + '/' + feedback.share_key + '/' + window.location.search;
                window.location = feedback_url;
            }
        });
    },

    renameDesign: function(new_name) {
        if (this.model.get('page') === new_name) {
            return;
        }

        this.model.set('page', new_name);
        this.setPageTitle();

        Cache.app.request({
            action: 'feedback/rename',
            context: this,
            data: {
                id: this.model.id,
                name: new_name
            },
            success: function() {
                var success_text = this.$el.find('.feedback-title-success');

                success_text.show();

                setTimeout(function() {
                    success_text.hide();
                }, 2000);
            }
        });
    },

    renameFeedbackTitle: function(new_title) {
        if (this.model.get('title') === new_title) {
            return;
        }

        this.model.set('title', new_title);
        this.setPageTitle();

        Cache.app.request({
            action: 'feedback/updateTitle',
            data: {
                id: this.model.id,
                title: new_title
            },
            success: () => {
                var success_text = this.$el.find('.feedback-title-success');

                success_text.show();

                setTimeout(() => {
                    success_text.hide();
                }, 2000);
            }
        });
    },

    postComment: function(screenshot_num, screen_number, screen_x, screen_y, start_x, start_y, annotation_type, on_success) {
        var screenshot_id = Cache.feedback_screenshot.at(screenshot_num) ? Cache.feedback_screenshot.at(screenshot_num).id : 0;

        var _doPost = () => {
            var anon_user = Cache.getGuestUser();

            Cache.app.request({
                action: 'feedback\\comment/addPinComment',
                data: {
                    screenshot_id     : screenshot_id,
                    screenshot_num    : screenshot_num,
                    screen_x          : screen_x,
                    screen_y          : screen_y,
                    start_x           : start_x,
                    start_y           : start_y,
                    screen_number     : screen_number,
                    annotation_type   : annotation_type,
                    anon_email        : Cache.real_user_id ? '' : anon_user.email,
                    anon_name         : Cache.real_user_id ? '' : anon_user.name,
                },
                success: (feedback_comment_data) => {
                    Cache.feedback_comment.add(feedback_comment_data);

                    if (on_success) {
                        on_success();
                    }
                }
            });
        };

        if (Cache.real_user_id) {
            _doPost();
        } else {
            var anon_user = Cache.getGuestUser();

            if (anon_user.email && anon_user.name) {
                _doPost();
            } else {
                Modals.viewerGuest(_doPost);
            }
        }
    },

    recordVideo: function() {
        var _doPost = () => {
            var anon_user = Cache.getGuestUser();

            var _resetButton = () => {
                this.is_video_recording = false;
                this.$el.removeAttr('fullscreen');

                Util.transitionEnd(this.$el.find('.grid-main'), () => {
                    $(window).trigger('resize');
                });
            };

            var _onSubmit = (video_blob) => {
                _resetButton();

                Cache.app.request({
                    action: 'feedback\\comment/addVideoCapture',
                    data: {
                        screenshot_num : this.screenshot_num,
                        anon_email     : Cache.real_user_id ? '' : anon_user.email,
                        anon_name      : Cache.real_user_id ? '' : anon_user.name,
                    },
                    success: (response) => {
                        Cache.feedback_comment.add(response.data);
                        this.views.thread['_' + response.data.id].renderVideoCapture(video_blob, response.presigned_url, response.object_url);
                    }
                });
            };

            Util.transitionEnd(this.$el.find('.grid-main'), () => {
                Video_Capture.start({
                    onSubmit: _onSubmit,
                    onCancel: _resetButton
                });
            });

            this.is_video_recording = true;
            this.$el.attr('fullscreen', 1);
        };

        if (Cache.real_user_id) {
            _doPost();
        } else {
            var anon_user = Cache.getGuestUser();

            if (anon_user.email && anon_user.name) {
                _doPost();
            } else {
                Modals.viewerGuest(_doPost);
            }
        }
    },

    setAnnotationTipPos: function(e) {
        this.$el.find('.annotation-cursor-hint').css({
            top  : e.clientY - 50,
            left : e.clientX + 5
        });
    },

    updateCommentsTotal: function() {
        var total = 0;

        if (this.model.get('description')) {
            total++;
        }

        Cache.feedback_comment.each(function(model) {
            if (model.get('video_time') === 0 || model.get('comment')) {
                total++;
            }
        });

        this.$el.find('.comment-toggle').text(total + ' Comment' + (total === 1 ? '' : 's'));
    },

    updateCommentTypeDropdown: function() {
        this.$el.find('.comment-type-selection ul').html(
            '<li data-type="all">'      + (this.comment_type === 'all'      ? '<i class="far fa-check"></i>' : '<span class="icon-placeholder"></span>') + 'All</li>' +
            '<li data-type="open">'     + (this.comment_type === 'open'     ? '<i class="far fa-check"></i>' : '<span class="icon-placeholder"></span>') + 'Unresolved</li>' +
            '<li data-type="resolved">' + (this.comment_type === 'resolved' ? '<i class="far fa-check"></i>' : '<span class="icon-placeholder"></span>') + 'Resolved</li>'
        );

        var comment_label = '';

        if (this.comment_type === 'open') {
            comment_label = 'Unresolved';
        } else if (this.comment_type === 'resolved') {
            comment_label = 'Resolved';
        } else {
            comment_label = 'All';
        }

        this.$el.find('.comment-type-selection button > span').html(comment_label);
        this.$el.attr('commenttype', this.comment_type);

        this.updateCommentEmptyState();
    },

    updateCommentEmptyState: function() {
        var is_empty       = false;
        var open_count     = 0;
        var resolved_count = 0;

        if (this.model.get('is_desc_resolved')) {
            resolved_count++;
        } else {
            open_count++;
        }

        _.each(Cache.feedback_comment.where({feedback_id: this.model.id, screenshot_num: this.screenshot_num}), function(model) {
            if (!model.get('reply_comment_id') && (model.get('screen_x') || model.get('video_number') || model.get('video_time'))) {
                if (model.get('is_resolved')) {
                    resolved_count++;
                } else {
                    open_count++;
                }
            }
        });

        if (open_count + resolved_count === 0 && this.model.get('load_type') !== 'upload') {
            if (this.model.get('is_desc_resolved')) {
                resolved_count++;
            } else {
                open_count++;
            }
        }

        if (this.comment_type === 'open') {
            is_empty = open_count === 0;
        } else if (this.comment_type === 'resolved') {
            is_empty = resolved_count === 0;
        } else {
            is_empty = open_count === 0 && resolved_count === 0;
        }

        if (is_empty) {
            var empty_state_text = 'No comments yet.';

            if (this.comment_type === 'open') {
                empty_state_text = '<i class="fad fa-laugh-beam text-success"></i>' +
                                    '<p>Woohoo! All comments have been resolved.</p>' +
                                    (resolved_count ?
                                    '<a class="view-resolved-comments info" href="#">View resolved comments</a>' : '');
            } else if (this.comment_type === 'resolved') {
                empty_state_text = '<i class="fad fa-comment-alt-lines info"></i>' +
                                    '<h3 class="margin-top-24">No resolved comments yet</h3>' +
                                    '<p class="info margin-top-4">Once comments are resolved, they will be displayed here.</p>' +
                                    (open_count ?
                                    '<a class="view-open-comments" href="#">View open comments</a>' : '');
            }

            this.$el.find('.comment-list-empty-state').html(empty_state_text).show();
        } else {
            this.$el.find('.comment-list-empty-state').hide();
        }
    },

    canUploadDesign: function() {
        return Cache.real_user_id && !Cache.app.isClient() && this.isDesign();
    },

    hasUnsavedChanges: function() {
        // new reply or new notes
        var has_unsaved_comments = false;
        this.$el.find('.thread-reply-form .new-comment').each(function() {
            if (!$(this).is(':empty')) {
                has_unsaved_comments = true;
            }
        });

        return has_unsaved_comments;
    },

    canComment: function() {
        var can_comment = Cache.real_user_id || (this.model && this.model.get('allow_public_comment'));
        return can_comment;
    },

    hasVideo: function() {
        return true;
    },

    isPdf: function() {
        return this.model && this.model.isPdf();
    },

    isDesign: function() {
        return this.model && this.model.isDesign();
    },

    isVideoUpload: function() {
        return this.model && this.model.isVideoUpload();
    },

    isApprover: function() {
        if (!Cache.real_user_id) {
            return false;
        }

        if (!this.model) {
            return false;
        }

        return Cache.feedback_approver.where({feedback_id: this.model.id, user_id: Cache.real_user_id}).length > 0;
    },

    displayDevTools: function() {
        if (Cache.real_user_id && !Cache.app.isClient()) {
            return true;
        }

        return false;
    },

    displaySessionRecording: function() {
        if (Cache.real_user_id && !Cache.app.isClient()) {
            return true;
        }

        return false;
    },

    initialize: function(options) {
        this.in_app                = Router.getQueryString('in_app') == 1;
        this.inbox_view            = Router.getQueryString('inbox') == 1;
        this.unsubscribe_key       = Router.getQueryString('u');
        this.unsubscribe_email     = Router.getQueryString('ue');
        this.not_found             = options && options.not_found !== undefined ? !!options.not_found : false;

        var console_open           = Router.getQueryString('cl') == 1;
        var theater_moode          = Router.getQueryString('th') == 1;

        if (!Cache.feedback || Cache.feedback.length === 0) {
            this.not_found = true;
        }

        if (this.not_found) {
            return;
        }

        // reset object on nav
        this.screenshot_zoom_level_cache = {};

        this.model = Cache.feedback.at(0);

        if ((this.isDesign() || this.isPdf()) && this.canComment()) {
            this.tool_type = 'square';
        }

        // default screenshot num
        if (this.isDesign()) {
            var default_num;

            Cache.feedback_screenshot.each((model, index) => {
                if (model.get('is_approved')) {
                    default_num = index;
                }
            });

            // default to last revision when there isn't an approved one;
            if (default_num === undefined) {
                default_num = Cache.feedback_screenshot.length - 1;
            }

            this.screenshot_num = default_num;
        }

        this.$el.attr('tooltype', this.tool_type);

        if (this.isPdf()) {
            this.$el.attr('loadtype', 'pdf');
        } else if (this.isDesign()) {
            this.$el.attr('loadtype', 'design');
        } else {
            if (this.model.get('video_url')) {
                this.$el.attr('loadtype', 'video');
            } else {
                this.$el.attr('loadtype', 'screenshot');
            }

            this.$el.attr('screenshotnum', Cache.feedback_screenshot.length);
        }

        if (console_open) {
            this.$el.attr('devtool', 'console');
        }

        if (theater_moode) {
            this.$el.attr('theater', 1);
        }

        // create views
        if (this.model.get('video_url')) {
            this.views.video_player = new View_Feedback_Video_Player({
                model: this.model,
                dispatcher: this.dispatcher
            });
        }

        this.views.actions     = new View_Feedback_Actions({model: this.model});
        this.views.details     = new View_Feedback_Details({model: this.model});
        this.views.dev_tools   = new View_Dev_Tools({
            feedback_id: this.model.id,
            show_event: true,
            is_console_logs_loaded: true,
            is_network_logs_loaded: true,
            is_event_logs_loaded: true,
        });
        this.views.session     = new View_Feedback_Session_Recording({model: this.model});

        this.views.revision_dropdown = new View_Feedback_Revision_Dropdown({
            model: this.model,
            dispatcher: this.dispatcher,
            screenshot_num: () => {
                return this.screenshot_num;
            }
        });

        this.views.pdf_pagination = new View_Feedback_Pdf_Pagination({
            model: this.model,
            dispatcher: this.dispatcher
        });

        if (!this.isDesign() && !this.isPdf() && !this.model.get('video_url')) {
            Cache.feedback_screenshot.each((model) => {
                this.newScreenshotThumbnailView(model);
            });
        }

        var thread_count = 0;

        // description thread
        this.newThreadView();
        thread_count++;

        _.each(Cache.feedback_comment.where({feedback_id: this.model.id}), (model) => {
            if (model.get('screen_x') && model.get('screen_y')) {
                // pin comment
                this.newPinCommentView(model);
            }

            if (!model.get('reply_comment_id') && (model.get('screen_x') || model.get('video_number') || model.get('video_time'))) {
                this.newThreadView(model);
                thread_count++;
            }
        });

        if (['all', 'open', 'resolved'].indexOf(Router.getQueryString('s')) !== -1) {
            this.comment_type = Router.getQueryString('s');
        }

        var comment_id  = Router.getQueryString('c');
        if (comment_id) {
            var thread_view = this.views.thread['_' + comment_id];

            if (thread_view) {
                var is_resolved;

                if (comment_id === 'desc') {
                    is_resolved = this.model.get('is_desc_resolved');
                } else {
                    is_resolved = Cache.feedback_comment.get(comment_id).get('is_resolved');
                }

                if (is_resolved && this.comment_type === 'open') {
                    this.comment_type = 'resolved';
                } else if (!is_resolved && this.comment_type === 'resolved') {
                    this.comment_type = 'open';
                }
            }
        }

        this.views.details.on('openFeedback', this.openFeedback.bind(this));

        // bind events
        this.listenTo(this.model, 'change:screenshot',              this.event_handlers.screenshotChange);
        this.listenTo(this.model, 'change:is_desc_resolved',        this.event_handlers.onCommentResolve);
        this.listenTo(this.model, 'change:page',                    this.event_handlers.onPageChange);
        this.listenTo(this.model, 'change:allow_video_feedback',    this.event_handlers.onShareSettingsChange);
        this.listenTo(this.model, 'change:description',             this.event_handlers.onDescriptionChange);

        this.listenTo(Cache.feedback_comment, 'add',                this.event_handlers.onCommentAdd);
        this.listenTo(Cache.feedback_comment, 'remove',             this.event_handlers.onCommentRemove);
        this.listenTo(Cache.feedback_comment, 'change:comment',     this.event_handlers.onCommentChange);
        this.listenTo(Cache.feedback_comment, 'change:is_resolved', this.event_handlers.onCommentResolve);

        var _onGuestUpdate        = this.event_handlers.onGuestUpdate.bind(this);
        var _onThreadSelect       = this.event_handlers.onThreadSelect.bind(this);
        var _onPinCommentOpen     = this.event_handlers.onPinCommentOpen.bind(this);
        var _onThumbnailSelect    = this.event_handlers.onScreenshotThumbnailSelect.bind(this);
        var _onPdfThumbnailSelect = this.event_handlers.onPdfThumbnailSelect.bind(this);
        var _windowResize         = this.dom_handlers.windowResize.bind(this);
        var _windowBeforeUnload   = this.dom_handlers.windowBeforeUnload.bind(this);
        var _documentKeydown      = this.dom_handlers.documentKeydown.bind(this);
        var _documentKeyup        = this.dom_handlers.documentKeyup.bind(this);

        Cache.app.dispatcher.on('Viewer:guestUpdate', _onGuestUpdate);

        this.dispatcher.on('Thread:Select',               _onThreadSelect);
        this.dispatcher.on('Pin_Comment:Open',            _onPinCommentOpen);
        this.dispatcher.on('Screenshot_Thumbnail:Select', _onThumbnailSelect);
        this.dispatcher.on('Pdf_Thumbnail:Select',        _onPdfThumbnailSelect);

        $(window).on('resize',       _windowResize);
        $(window).on('beforeunload', _windowBeforeUnload);
        $(document).on('keydown', _documentKeydown);
        $(document).on('keyup',   _documentKeyup);

        // when the viewer is opened publicly, the polling should not be required
        if (Cache.real_user_id) {
            Cache.feedback.startPolling();
        }

        this.on('remove', function() {
            Cache.app.dispatcher.off('Viewer:guestUpdate', _onGuestUpdate);

            this.dispatcher.off('Thread:Select',               _onThreadSelect);
            this.dispatcher.off('Pin_Comment:Open',            _onPinCommentOpen);
            this.dispatcher.off('Screenshot_Thumbnail:Select', _onThumbnailSelect);
            this.dispatcher.off('Pdf_Thumbnail:Select',        _onPdfThumbnailSelect);

            $(window).off('resize',       _windowResize);
            $(window).off('beforeunload', _windowBeforeUnload);
            $(document).off('keydown', _documentKeydown);
            $(document).off('keyup',   _documentKeyup);

            Cache.feedback.stopPolling();
        });

        if (this.in_app) {
            var parent_window = window.parent;

            if (parent_window !== window) {
                window.hasUnsavedChanges = this.hasUnsavedChanges.bind(this);
            };
        }
    },

    initializeSnap: function() {
        this.snap = Snap_SVG('.annotation-canvas');
        this.snap.drag(this.dom_handlers.drawMove.bind(this),
                        this.dom_handlers.drawStart.bind(this),
                        this.dom_handlers.drawStop.bind(this));

        this.snap.touchstart(this.dom_handlers.touchStart.bind(this));
        this.snap.touchmove(this.dom_handlers.touchMove.bind(this));
        this.snap.touchcancel(this.dom_handlers.touchStop.bind(this));
        this.snap.touchend(this.dom_handlers.touchStop.bind(this));
    },

    newScreenshotThumbnailView: function(model) {
        this.views.screenshot_thumbnail['_' + model.id] = new View_Feedback_Screenshot_Thumbnail({
            model      : model,
            feedback   : this.model,
            dispatcher : this.dispatcher
        });

        return this.views.screenshot_thumbnail['_' + model.id]
    },

    renderScreenshotThumbnail: function(view) {
        view.render().$el.appendTo(this.$el.find('.region-thumbnails'));
    },

    newThreadView: function(model) {
        var view_index = model ? model.id : 'desc';

        this.views.thread['_' + view_index] = new View_Feedback_Thread({
            model      : model,
            feedback   : this.model,
            dispatcher : this.dispatcher,
            is_viewer  : true
        });

        return this.views.thread['_' + view_index];
    },

    newPinCommentView: function(model) {
        this.views.pin_comments['_' + model.id] = new View_Feedback_Pin_Comment({
            model      : model,
            feedback   : this.model,
            dispatcher : this.dispatcher
        });

        return this.views.pin_comments['_' + model.id];
    },

    renderThread: function(new_view, check_order) {
        if (check_order) {
            var view_after;

            _.each(this.views.thread, function(view) {
                if (view.model && view.model.get('video_time')) {
                    if (view.model.get('video_time') > new_view.model.get('video_time')) {
                        if (!view_after || view_after.model.get('video_time') > view.model.get('video_time')) {
                            view_after = view;
                        }
                    }
                }
            });

            if (view_after) {
                new_view.render().$el.insertBefore(view_after.$el);
            } else {
                new_view.render().$el.appendTo(this.$el.find('.region-comment-list'));
            }
        } else {
            new_view.render().$el.appendTo(this.$el.find('.region-comment-list'));
        }

        if (new_view.model && new_view.model.get('screenshot_num') === this.screenshot_num) {
            new_view.show();
        }
    },

    renderPinComment: function(view) {
        view.setSnap(this.snap);
        view.render().$el.appendTo(this.$el);
    },

    zoomScreenshot: function() {
        if (!this.model.get('screenshot') || !this.screenshot_width || !this.screenshot_height) {
            return;
        }

        var min_width  = 100;
        var new_width  = Math.max(this.screenshot_width * this.screenshot_zoom_level / 100, min_width);
        var new_height = new_width / (this.screenshot_width / this.screenshot_height);

        var canvas        = this.$el.find('.region-screenshot');
        var screenshot_el = this.isPdf() ? this.$el.find('.pdf-viewer') : this.$el.find('.screenshot');

        var top  = Math.max(0, (canvas.height() - new_height) / 2);
        var canvas_padding_left = parseInt(canvas.css('padding-left'), 10);
        var canvas_padding_top  = parseInt(canvas.css('padding-top'), 10);

        screenshot_el.css({
            width  : new_width,
            height : new_height
        });

        if (this.isPdf() || this.isDesign()) {
            this.$el.find('.annotation-canvas').css({
                width  : new_width,
                height : new_height,
                top    : top,
                left   : Math.max(canvas_padding_left, screenshot_el.offset().left)
            });
        }

        if (this.model.get('is_auto_screenshot')) {
            var auto_screenshot_badge = this.$el.find('.screenshot-auto-badge');
            auto_screenshot_badge.css({
                left: screenshot_el.offset().left ,
                top:  screenshot_el.offset().top - canvas.offset().top + screenshot_el.height() - auto_screenshot_badge.outerHeight(),
            });
        }

        if (this.isDesign() || this.isPdf()) {
            this.$el.find('.zoom-level').text(this.screenshot_zoom_level + '%');
        }

        this.dispatcher.trigger('Screenshot:Update', {
            screenshot_num : this.screenshot_num,
            zoom           : this.screenshot_zoom_level,
            width          : this.screenshot_width,
            height         : this.screenshot_height,
            left           : canvas_padding_left + parseInt(screenshot_el.css('margin-left'), 10) - canvas.scrollLeft() + canvas.offset().left,
            top            : top + canvas_padding_top + this.$el.find('.region-heading:visible').height() - canvas.scrollTop()
        });
    },

    fitScreen: function() {
        if (this.screenshot_zoom_level_cache[this.screenshot_num]) {
            this.screenshot_zoom_level = this.screenshot_zoom_level_cache[this.screenshot_num];
            return;
        }

        var canvas_width     = this.$el.find('.region-screenshot').width();  // leave 20px margin
        var canvas_height    = this.$el.find('.region-screenshot').height();
        var screenshot_ratio = this.screenshot_width / this.screenshot_height;

        if (screenshot_ratio < 0.8 && !this.isPdf()) {
            // super tall image
            // ignore height
            // calculate zoom for with only
            if (canvas_width >= this.screenshot_width) {
                this.screenshot_zoom_level = 100;
            } else {
                var gutter = UI.isMobile() ? 0 : 300;
                var new_width = Math.max(0, canvas_width - gutter);
                this.screenshot_zoom_level = Math.floor(new_width / this.screenshot_width * 100);
            }
        } else {
            if (canvas_width < this.screenshot_width && canvas_height >= this.screenshot_height) {
                // too wide
                var new_width  = canvas_width;

                this.screenshot_zoom_level = Math.floor(new_width / this.screenshot_width * 100);
            } else if (canvas_width >= this.screenshot_width && canvas_height < this.screenshot_height) {
                // too tall
                var new_height = canvas_height;
                var new_width  = screenshot_ratio * new_height;

                this.screenshot_zoom_level = Math.floor(new_width / this.screenshot_width * 100);
            } else if (canvas_width < this.screenshot_width && canvas_height < this.screenshot_height) {
                // too wide and too tall
                // step 1: resize width
                var new_width  = canvas_width;
                var new_height = new_width / screenshot_ratio;

                // step 2: resize height
                if (new_height > canvas_height) {
                    new_height = canvas_height ;
                    new_width  = screenshot_ratio * new_height;
                }

                this.screenshot_zoom_level = Math.floor(new_width / this.screenshot_width * 100);
            } else {
                this.screenshot_zoom_level = 100;
            }
        }

        this.screenshot_zoom_level = Math.max(this.screenshot_zoom_level, 10); // min 10% on load otherwise image will be way too small
        this.screenshot_zoom_level = this.screenshot_zoom_level - this.screenshot_zoom_level % 5; // increment is 5

        // cache
        this.screenshot_zoom_level_cache[this.screenshot_num] = this.screenshot_zoom_level;
    },

    load: function() {
        Cache.app.request({
            action: 'feedback/load',
            data : {}, // no data needs to be posted, all parameters are in the url
            context: this,
            success: function(response) {
                if (response.feedback && response.feedback.length) {
                    Router.addQueryString('k', response.feedback[0].share_key);
                    Cache.app.setData(response);
                    UI.buildPage('viewer');
                }
            }
        });
    },

    // when a pdf or a screenshot is loaded
    viewOnLoad: function() {
        this.fitScreen();
        this.zoomScreenshot();

        var count = 0;
        _.each(this.views.pin_comments, (view) => {
            if (view.model.get('screenshot_num') === this.screenshot_num) {
                setTimeout(function() {
                    view.show();
                }, count * 100 + 200);

                count++;
            } else {
                view.hide();
            }
        });

        _.each(this.views.thread, (view) => {
            if (view.model && view.model.get('screenshot_num') === this.screenshot_num) {
                view.show();
            } else if (!view.model) {
                view.show();
            } else {
                view.hide();
            }
        });

        this.updateCommentEmptyState();
    },

    viewScreenshot: function(num) {
        this.screenshot_num = num;

        var screenshot_url = this.model.get('screenshot');
        var screenshot_model = Cache.feedback_screenshot.at(num);

        if (screenshot_model) {
            screenshot_url = screenshot_model.get('url');

            this.model.set({
                'screenshot' : screenshot_url,
                'window_x'   : screenshot_model.get('window_x'),
                'window_y'   : screenshot_model.get('window_y')
            });
        }

        this.$el.find('img.screenshot').removeClass('loaded');

        var image = new Image();

        image.onload = () => {
            this.$el.find('img.screenshot').addClass('loaded');

            this.screenshot_width  = image.width;
            this.screenshot_height = image.height;

            this.viewOnLoad();
        };

        image.src = screenshot_url;

        this.setPageTitle();
    },

    viewPdf: function(num) {
        this.screenshot_num = num;

        var _onLoad = (pdf) => {
            var new_canvas = $('<canvas>').addClass('pdf-viewer');

            pdf.getPage(num + 1).then((page) => {
                var scale     = 2; // scale 2 for retina display and better zoom quality
                var viewport  = page.getViewport({scale: scale});
                var canvas    = new_canvas.get(0);
                var context   = canvas.getContext('2d');

                canvas.width  = viewport.width;
                canvas.height = viewport.height;

                page.render({
                    canvasContext: context,
                    viewport: viewport
                }).promise.then(() => {
                    // remove old canvas first because pdf cant be rendered on the same canvas again
                    this.$el.find('canvas.pdf-viewer').remove();
                    new_canvas.appendTo(this.$el.find('.region-screenshot'));

                    this.screenshot_width  = viewport.width / scale;
                    this.screenshot_height = viewport.height / scale;

                    this.viewOnLoad();
                });
            });
        };

        if (typeof this.pdf_cache[this.model.get('screenshot')] !== 'undefined') {
            _onLoad(this.pdf_cache[this.model.get('screenshot')]);
        } else {
            PDFJS
                .getInstance()
                .getDocument(this.model.get('screenshot'))
                .promise.then((pdf) => {
                    this.pdf_cache[this.model.get('screenshot')] = pdf;
                    _onLoad(pdf);
                }, (reason) => {
                    UI.error(reason);
                });
        }
    },

    setPageTitle: function() {
        var title = '';

        if (this.model.get('load_type') === 'upload') {
            title = this.model.get('page');

            if (this.model.isDesign()) {
                title += ' (v' + (this.screenshot_num + 1) + ')';
            }
        } else if (this.model.get('title')) {
            title = this.model.get('title');
        } else {
            title = 'Feedback: #' + Util.padLeft(this.model.id, '000000');
        }

        document.title = title;
    },

    onPageReady: function() {
        if (this.not_found) {
            return;
        }

        if (this.unsubscribe_key && this.unsubscribe_email) {
            Cache.app.request({
                action: 'feedback/unsubscribe',
                data : {
                    id    : this.model.id,
                    key   : this.unsubscribe_key,
                    email : this.unsubscribe_email
                },
                error: function() {
                    // ignore
                }
            });

            return;
        }

        if (this.isDesign() || this.isPdf()) {
            this.initializeSnap();
        }

        // render pin comments and view the first screenshot
        if (this.model.get('screenshot')) {
            // scroll event doesn't bubble up to backbone events, so we need to manually bind it here
            this.$el.find('.region-screenshot').on('scroll', () => {
                this.zoomScreenshot();
            });

            _.each(this.views.pin_comments, (view) => {
                this.renderPinComment(view);
            });

            if (this.model.isPdf()) {
                this.viewPdf(this.screenshot_num);
            } else {
                this.viewScreenshot(this.screenshot_num);
            }

            // hack: set the default active class
            // after this, the active class is properly handled in the screenshot thumbnail view
            this.$el.find('.screenshot-thumbnail').eq(this.screenshot_num).addClass('active');
        }

        // default tab
        var tab         = Router.getQueryString('t');
        var comment_id  = Router.getQueryString('c');

        if (comment_id) {
            var thread_view = this.views.thread['_' + comment_id];

            if (thread_view) {
                var open_reply = Router.getQueryString('r') == 1;
                this.views.thread['_' + comment_id].select(open_reply);

                tab = ''; // comments
            } else {
                // not a main thread
                // maybe a child comment?
                // this is handeled in the reply_comment.js view
            }
        }

        if (tab === 'd') {
            this.$el.find('.details-toggle').trigger('click');
        }

        // open new thread comment editor
        _.each(this.views.thread, (view) => {
            view.openReply();
        });

        this.updateCommentEmptyState();
        this.setPageTitle();

        $(window).trigger('resize');

        var session_replay = Router.getQueryString('sr') == 1;

        if (session_replay && this.displaySessionRecording()) {
            this.$el.find('.session-replay-thumbnail').click();
        }

        if (Cache.app.isSuperAdmin()) {
            setInterval(this.sessionPollilng, 5000);
        }
    },

    sessionPollilng: function() {
        Cache.app.request({
            action: 'app/idle',
            success: function(response) {
                if (response.user_id !== Cache.real_user_id) {
                    if (this.session_logged_out) {
                        // modal is already showing
                        return;
                    }

                    Modal.open({
                        title: 'Logged Out',
                        content: '<p>You are logged in to a different account.</p>',
                        button: {
                            OK: () => {
                                Modal.close();
                            }
                        }
                    });

                    this.session_logged_out = true;
                } else {
                    if (!this.session_logged_out) {
                        return;
                    }

                    Modal.close();
                    this.session_logged_out = false;
                }
            }
        });
    },

    renderAnnotationTools: function() {
        if (!this.canComment()) {
            return;
        }

        if (!this.isDesign() && !this.isPdf()) {
            return;
        }

        var html = '<button data-type="eye" class="tooltip' + (this.tool_type === 'eye-open' ? ' active' : '') + '" data-title="View Mode">' +
                        '<i class="fad fa-fw fa-eye"></i>' +
                    '</button>' +
                    '<button data-type="eye-open" class="tooltip' + (this.tool_type === 'eye' ? ' active' : '') + '" data-title="View Mode">' +
                        '<i class="fad fa-fw fa-eye"></i>' +
                    '</button>' +
                    '<button data-type="square" class="tooltip' + (this.tool_type === 'square' ? ' active' : '') + '" data-title="Highlight">' +
                        '<i class="fad fa-fw fa-draw-square"></i>' +
                    '</button>' +
                    '<button data-type="arrow" class="tooltip' + (this.tool_type === 'arrow' ? ' active' : '') + '" data-title="Arrow">' +
                        '<i class="far fa-fw fa-long-arrow-alt-up"></i>' +
                    '</button>' +
                    '<button data-type="comment" class="tooltip' + (this.tool_type === 'comment' ? ' active' : '') + '" data-title="Comment">' +
                        '<i class="fad fa-fw fa-comment-plus"></i>' +
                    '</button>' +
                    (this.hasVideo() && this.model.get('allow_video_feedback') ?
                    '<button data-type="video" class="tooltip" data-title="Record Video">' +
                        '<i class="fad fa-fw fa-video"></i>' +
                    '</button>' : '');

        this.$el.find('.annotation-tools').html(html);
    },

    renderUserProfile: function() {
        var profile_img;
        var profile_name;

        if (Cache.real_user_id) {
            profile_img   = Cache.getRealUser().getAvatar(64);
            profile_name  = Cache.getRealUser().get('name');
        } else {
            var anon_user = Cache.getGuestUser();
            if (anon_user.email) {
                profile_img   = Util.gravatar(anon_user.email, 64, anon_user.name);
                profile_name  = anon_user.name;

                this.$el.find('.profile-img').addClass('profile-img-anon').show();
            } else {
                this.$el.find('.profile-img').hide();
            }
        }

        if (profile_img) {
            var html = '<img src="' + Util.htmlEntities(profile_img) + '">' +
                       '<div>' + Util.htmlEntities(profile_name) + ' (<i class="fas fa-circle"></i>online)</div>';

            this.$el.find('.profile-img').html(html);
        }
    },

    render: function() {
        var content = '';

        if (this.not_found) {
            content += '<div class="not-found">' +
                            '<div class="logo">' + SVG.logo_simple + '</div>' +
                            '<div class="invalid-url">You do not have access to this link.</div>' +
                            '<div class="contact-owner"><a href="/login/">Log in</a> or contact the project owner for a new url.</div>' +
                        '</div>';
        } else if (this.unsubscribe_key && this.unsubscribe_email) {
            content += '<div class="not-found">' +
                            '<div class="unsub-logo"><i class="far fa-bell-slash"></i></div>' +
                            '<div class="invalid-url">Unsubscribed Successfully!</div>' +
                            '<div class="contact-owner">You will no longer receive notifications about this feedback.</div>' +
                        '</div>';
        } else {
            var details_tab_name = 'Details';

            content += '<div class="region-heading">';

            if (this.in_app) {
                content += '<a href="#" class="viewer-close">' +
                                '<div>' +
                                    '<i class="fas fa-arrow-left"></i>' +
                                    '<span>ESC</span>' +
                                '</div>' +
                            '</a>';
            } else {
                var design_page = '/' + Cache.project.get(this.model.get('project_id')).get('project_key') + (this.isDesign() || this.isPdf() ? '/feedback/design/' : '/feedback/');
                var app_logo = SVG.logo_simple;
                var has_custom_logo = Cache.branding.length && Cache.branding.at(0).get('app_logo');

                if (has_custom_logo) {
                    app_logo = '<img src="' + Cache.branding.at(0).escape('app_logo') + '">' +
                               '<div class="powered-by-text">Powered by <b>Userback</b></div>';
                }

                content += '<div class="logo' + (has_custom_logo ? ' powered-by' : '') + '">' +
                                '<a href="' + (Cache.real_user_id ? design_page : 'https://www.userback.io') + '">' + app_logo + '</a>' +
                            '</div>';
            }

            var title = this.model.get('load_type') === 'upload' ? this.model.get('page') : this.model.get('title');

            content += '<div class="feedback-title">' +
                            '<div class="sup">' +
                                '<span>#' + Util.padLeft(this.model.id, '000000') + '</span>' +
                            '</div>' +
                            '<div class="sub">' +
                                '<span class="feedback-title-edit" spellcheck="false"' + (Cache.real_user_id && !Cache.app.isClient() ? ' contenteditable' : '') + '>' + Util.htmlEntities(title) + '</span>' +
                                '<span class="feedback-title-success"><i class="fas fa-check-circle"></i></span>' +
                            '</div>' +
                        '</div>';

            content +=     '<button class="mobile-toggle"></button>' +
                            '<div class="profile-img"></div>' +
                            '<div class="region-actions"></div>' +
                        '</div>' +

                        (this.canUploadDesign() ?
                        '<div class="dropzone">' +
                            '<div>' +
                                '<span class="upload-icon"><i class="fad fa-cloud-upload-alt"></i></span>' +
                                '<p>Add more revisions (.png, .jpg or .gif) to this design</p>' +
                            '</div>' +
                        '</div>' : '') +

                        '<div class="grid-main">' +
                            '<div class="annotation-cursor-hint">' + (this.tool_type === 'comment' ? 'Click to add a comment' : 'Click and drag to start') + '</div>' +

                            (Cache.real_user_id && !Cache.app.isClient() && this.model.get('screenshot') && this.model.get('is_local') && Cache.getDefaultProject() && !Cache.getDefaultProject().get('is_local_dismissed') ?
                            '<div class="local-warning">' +
                                '<span>Is your screenshot from a local server or protected site? We can\'t access some resources. </span>' +
                                '<a href="https://support.userback.io/en/articles/5209187" target="help" rel="noopener">Let\'s fix it</a>' +
                                '<button class="local-warning-close"><i class="far fa-times"></i></button>' +
                            '</div>' : '' );

            if (this.model.get('screenshot')) {
                content += '<div class="region-screenshot" data-type="' + (this.isPdf() || this.isDesign() ? 'upload' : 'web') + '">' +
                                (this.isPdf() ? '' : '<img class="screenshot" src="' + this.model.get('screenshot') + '">') +
                                (this.isPdf() || this.isDesign() ? '<svg class="annotation-canvas"></svg>' : '') +

                                (this.isDesign() || this.isPdf() ? '' :
                                '<div class="zoom-controls" data-type="web">' +
                                    '<button class="zoom-in"><i class="far fa-plus"></i></button>' +
                                    '<button class="zoom-out"><i class="far fa-minus"></i></button>' +
                                '</div>') +
                                (this.model.get('is_auto_screenshot') ? '<div class="screenshot-auto-badge"><i class="far fa-camera"></i> Screenshot automatically generated</div>' : '') +
                            '</div>';
            } else if (this.model.get('video_url')) {
                content += '<div class="region-video"></div>';
            } else {
                content += '<div class="region-screenshot">' +
                                '<div class="no-screenshot">' +
                                    '<span><i class="far fa-ban"></i>No screenshot provided</span>' +
                                '</div>' +
                            '</div>';
            }

            if (this.displaySessionRecording) {
                content += '<div class="region-session-replay"></div>';
            }

            if (this.isDesign() || this.isPdf()) {
                content += '<div class="region-toolbar">' +
                                '<div class="annotation-tools"></div>' +
                                '<div class="zoom-controls" data-type="design">' +
                                    '<button class="primary primary-invert small zoom-out"><i class="far fa-minus"></i></button>' +
                                    '<button class="primary primary-invert small zoom-level"></button>' +
                                    '<button class="primary primary-invert small zoom-in"><i class="far fa-plus"></i></button>' +
                                '</div>' +
                            '</div>';
            } else {
                content += '<div class="region-screenshot-thumbnail">' +
                               '<span class="drag-handle"></span>' +
                               '<div class="region-thumbnails"></div>' +
                               '<div class="region-devtools"></div>' +
                           '</div>';
            }

            content += '</div>';

            content += '<div class="grid-sidebar">' +
                            '<div class="sidebar-toggle"><i class="far fa-angle-right"></i></div>' +
                            '<div class="region-tabs">' +
                                '<button class="comment-toggle active">Comments</button>' +
                                '<button class="details-toggle">' + details_tab_name + '</button>' +
                            '</div>' +

                            '<div class="region-comments">' +
                                (Cache.real_user_id ?
                                '<div class="comment-actions">' +
                                    '<div class="button-dropdown comment-type-selection">' +
                                        '<button type="button" class="text small"><span class="cap"></span> <i class="far fa-angle-down"></i></button>' +
                                        '<div>' +
                                            '<ul class="dropdown"></ul>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>' : '') +
                                '<div class="region-comment-list">' +
                                    '<div class="comment-list-empty-state"></div>' +
                                '</div>' +
                            '</div>' +

                            '<div class="region-details"></div>' +
                        '</div>';
        }

        this.$el.html(content);

        if (this.not_found || (this.unsubscribe_key && this.unsubscribe_email)) {
            return this;
        }

        if (this.in_app) {
            $(document.body).addClass('in-app');
        }

        if (this.inbox_view) {
            $(document.body).addClass('inbox-view');
        }

        if (Cache.real_user_id) {
            this.views.actions.render().$el.appendTo(this.$el.find('.region-actions'));
        }

        if (this.isDesign()) {
            this.views.revision_dropdown.render().$el.appendTo(this.$el.find('.region-toolbar'));
        } else if (this.isPdf()) {
            this.views.pdf_pagination.render().$el.appendTo(this.$el.find('.region-toolbar'));
        }

        this.views.details.render().$el.appendTo(this.$el.find('.region-details'));

        // thumbnail: screenshot
        _.each(this.views.screenshot_thumbnail, (view) => {
            this.renderScreenshotThumbnail(view);
        });

        // thumbnail: video
        if (this.model.get('video_url')) {
            this.$el.find('.region-thumbnails').append($('<div>').addClass('video-thumbnail active').html('<video muted src="' + this.model.get('video_url') + '"></video>'));
            this.views.video_player.render().$el.appendTo(this.$el.find('.region-video'));
        }

        // thumbnail: session replay
        if (this.displaySessionRecording()) {
            this.views.session.render().$el.appendTo(this.$el.find('.region-thumbnails'));
        }

        // thumbnail: dev tools
        if (this.displayDevTools()) {
            this.$el.find('.region-thumbnails').append($('<div>').addClass('devtools-thumbnail').html('<span class="icon"><i class="fas fa-code"></i></span><span class="text">Dev Tools</span>'));
            this.views.dev_tools.render().$el.appendTo(this.$el.find('.region-devtools'));
        }

        _.each(this.views.thread, (view) => {
            this.renderThread(view);
        });

        this.updateCommentsTotal();
        this.updateCommentTypeDropdown();
        this.renderAnnotationTools();
        this.renderUserProfile();

        this.$el.find('.drag-handle').draggable({
            axis: 'y',
            helper: 'clone',
            start: this.dom_handlers.onDragConsoleStart.bind(this),
            drag: this.dom_handlers.onDragConsolePanel.bind(this)
        });

        return this;
    }
});
